import PropTypes from "prop-types";
import React from "react";

const FaqQuestionAnswer = ({answerContent}) => (
  <div
    className="pb16"
  >
    {answerContent.map(answerSegment => (
      <p
        className="faq-answer pt4 small faq-bar"
        dangerouslySetInnerHTML={{"__html": answerSegment}} // eslint-disable-line react/no-danger
        key={answerSegment}
      />
    ))}
  </div>
);

FaqQuestionAnswer.propTypes = {"answerContent": PropTypes.arrayOf(String).isRequired};

export default FaqQuestionAnswer;
